import React from "react"

import { AlertContainer } from "@/components"
import { Link, Typography } from "@material-ui/core"

type ReportFeedbackAlertProps = {
	title?: string
	linkToForms: string
	linkDescription: string
}

const ReportFeedbackAlert: React.FC<ReportFeedbackAlertProps> = (props) => {
	const { title, linkToForms, linkDescription } = props

	return (
		<AlertContainer
			title={title ?? "Sua opinião é fundamental!"}
			alertType="info"
		>
			<Typography
				style={{
					fontSize: "14px",
					fontWeight: 400,
					lineHeight: "20px"
				}}
			>
				{linkDescription}
				<Link
					href={linkToForms}
					style={{ cursor: "pointer", marginLeft: "4px" }}
					target="_blank"
				>
					Clique aqui e contribua!
				</Link>
			</Typography>
		</AlertContainer>
	)
}

export default ReportFeedbackAlert
